import { createStorageAtomFactory, createInMemoryAtom, difference, } from '@exodus/atoms';
import { createFusionAtom } from '@exodus/fusion-atoms';
// Stores currently connected seed credential id. Flushed on lock.
const CURRENT_SEED_ID_FLAG = 'seedId';
const createCredentialIdAtom = ({ storage }) => createStorageAtomFactory({ storage })({
    defaultValue: undefined,
    key: CURRENT_SEED_ID_FLAG,
});
export const credentialIdAtomDefinition = {
    id: 'credentialIdAtom',
    type: 'atom',
    factory: createCredentialIdAtom,
    public: true,
    dependencies: ['storage'],
};
export const lockedAtomDefinition = {
    id: 'lockedAtom',
    type: 'atom',
    factory: () => createInMemoryAtom({ defaultValue: true }),
    dependencies: [],
};
export const autoUnlockingAtomDefinition = {
    id: 'autoUnlockingAtom',
    type: 'atom',
    factory: () => createInMemoryAtom({ defaultValue: true }),
    public: true,
    dependencies: [],
};
const MAX_ENTRIES = 10;
const createLockHistoryAtom = ({ lockedAtom }) => {
    const lockHistory = createInMemoryAtom({
        defaultValue: [],
    });
    difference(lockedAtom).observe(async ({ current: locked }) => {
        await lockHistory.set((current) => [{ locked, timestamp: new Date() }, ...current].slice(0, MAX_ENTRIES));
    });
    return lockHistory;
};
export const lockHistoryAtomDefinition = {
    id: 'lockHistoryAtom',
    type: 'atom',
    factory: createLockHistoryAtom,
    dependencies: ['lockedAtom'],
};
export const restoreAtomDefinition = {
    id: 'restoreAtom',
    type: 'atom',
    factory: () => createInMemoryAtom(),
    public: true,
    dependencies: [],
};
export const walletCreatedAtAtomDefinition = {
    id: 'walletCreatedAtAtom',
    type: 'atom',
    factory: ({ fusion, logger }) => createFusionAtom({
        fusion,
        logger,
        path: 'createdAt',
        defaultValue: new Date().toISOString(),
    }),
    dependencies: ['fusion', 'logger'],
};
